import axios from "axios";

export interface RatioResult {
  result: string;
  ratio: number;
}

export const CarUtils = {
  GetRatio: async (method: string, fpsoAreaId: string, token: string) => {
    return await axios
      .get<RatioResult[]>(`${process.env.REACT_APP_FILE_SERVER_URL}/car/${method}/${fpsoAreaId}`, {
        headers: {
          Authorization: token,
        },
      });
  },
};
